import { NumberFormatValues } from 'react-number-format';

export const validateNumericValue =
  (opts: { min?: number; max?: number }) => (value: NumberFormatValues) => {
    if (!value.floatValue) {
      return true;
    }
    if (opts.min !== undefined && value.floatValue < opts.min) {
      return false;
    }

    if (opts.max !== undefined && value.floatValue > opts.max) {
      return false;
    }

    return true;
  };
